import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardRoutingModule } from './dashboard-routing.module';
import { SharedModule } from 'src/app/@shared/shared.module';

import { DashboardComponent } from './dashboard/dashboard.component';
import { CasinoComponent } from './casino/casino.component';
import { SportListComponent } from './sport-list/sport-list.component';
import { CasinoDetailComponent } from './casino-detail/casino-detail.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { SwiperModule } from "swiper/angular";


@NgModule({
  declarations: [
    CasinoComponent,
    CasinoDetailComponent,
    DashboardComponent,
    SportListComponent,
  ],
  imports: [
    CommonModule, 
    DashboardRoutingModule,
    SharedModule,
    LazyLoadImageModule,
    SwiperModule
  ],
})
export class DashboardModule {}
